module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap_title"
  }, [_c('a', {
    attrs: {
      "id": "a108"
    }
  }), _vm._v("TABLES")]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a109"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/14_Chapter_4#a165"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 2.1:")]), _vm._v(" Reservation Rents")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a111"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_5#a181",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 3.1:")]), _vm._v(" A Family’s Necessity and Reservation Prices for Food")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a114"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_7#a191",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 5.1:")]), _vm._v(" Highest Marginal Tax Rate")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a115"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_8#a203",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 6.1:")]), _vm._v(" Economic and Revenue Growth: Selected Periods")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a118"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_9#a213",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 7.1:")]), _vm._v(" Reservation Prices for Breakfast Cereal")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a119"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_9#a215",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 7.2:")]), _vm._v(" Monopoly in the Breakfast Cereal Market")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a122"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_9#a219",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 7.3:")]), _vm._v(" The Breakfast Cereal Market with Smaller Inequality")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a123"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_9#a222",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 7.4:")]), _vm._v(" When the Rich Get Richer")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a125"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_10#a231",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 8.1:")]), _vm._v(" Funding Gaps in Education by State, 2001–2")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a127"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_10#a242",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 8.2:")]), _vm._v(" Average Class Size, Student/Teacher Ratios, 1999–2000")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a130"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_12#a262",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 9.1:")]), _vm._v(" Wheat Production")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a131"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_14#a293",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 11.1:")]), _vm._v(" Big Mac Wages Around the World")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a134"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_15#a300",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 12.1:")]), _vm._v(" Employment Before and After Increase of Minimum Wage")])]), _vm._v(" "), _c('p', {
    staticClass: "figtab-list"
  }, [_c('a', {
    attrs: {
      "id": "a136"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_16#a309",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("Table 13.1:")]), _vm._v(" Unemployment, 1923–1942")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b27ea3e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Tables.vue
// module id = 75
// module chunks = 0